
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, Schooling } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class SchoolingEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    schooling: Schooling;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getSchooling()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getSchooling(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.schooling = data;
                this.onDataChanged.next(this.schooling);
                resolve(this.schooling);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('schooling/' + this.routeParams.id).subscribe((res: Schooling ) => {
                    this.schooling = res;
                    this.onDataChanged.next(this.schooling);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(schooling): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('schooling/', schooling).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(schooling): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('schooling/', schooling).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(schooling): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('schooling/' + schooling.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): Schooling {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
